export type Project = {
  id: string;
  name: string;
  code: string;
  color: string; // for avatar chip
};

export type TicketStatus =
  | 'submitted'
  | 'in_progress'
  | 'blocked'
  | 'delivered'
  | 'closed'
  | 'triage';

export type Priority = 'low' | 'medium' | 'high' | 'urgent';

export type Ticket = {
  id: string;
  ticketNumber?: string;
  projectId: string;
  title: string;
  status: TicketStatus;
  priority: Priority;
  assignedTo?: string;
  offeringName?: string | null;
  offeringCode?: string | null;
  offeringSubcategoryName?: string | null;
  offeringSubcategoryId?: string | null;
  teamId?: string | null;
  owningTeamNodeId?: string | null;
  currentTeamNodeId?: string | null;
  defaultTeamNodeId?: string | null;
  currentTeamLabel?: string | null;
  defaultTeamLabel?: string | null;
  updatedAt: string; // ISO
  unread?: boolean;
};

export const projects: Project[] = [
  { id: 'p1', name: 'Brand Refresh', code: 'BR', color: '#A78BFA' },
  { id: 'p2', name: 'Ecommerce Site', code: 'EC', color: '#34D399' },
  { id: 'p3', name: 'Ad Campaign Q4', code: 'AD', color: '#60A5FA' },
];

export const tickets: Ticket[] = [
  {
    id: 't1',
    projectId: 'p2',
    title: 'Checkout bug on Safari',
    status: 'in_progress',
    priority: 'urgent',
    assignedTo: 'Alex',
    updatedAt: new Date(Date.now() - 1000 * 60 * 25).toISOString(),
    unread: true,
  },
  {
    id: 't2',
    projectId: 'p2',
    title: 'Product detail page performance',
    status: 'submitted',
    priority: 'high',
    updatedAt: new Date(Date.now() - 1000 * 60 * 90).toISOString(),
  },
  {
    id: 't3',
    projectId: 'p1',
    title: 'Logo lockup - round 2 revisions',
    status: 'blocked',
    priority: 'medium',
    assignedTo: 'Priya',
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 12).toISOString(),
    unread: true,
  },
  {
    id: 't4',
    projectId: 'p1',
    title: 'Brand guideline PDF delivery',
    status: 'delivered',
    priority: 'low',
    assignedTo: 'Sam',
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 3).toISOString(),
  },
  {
    id: 't5',
    projectId: 'p3',
    title: 'Landing page hero animation',
    status: 'triage',
    priority: 'medium',
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 18).toISOString(),
  },
];

export function timeAgo(iso: string) {
  const s = Math.max(1, Math.floor((Date.now() - Date.parse(iso)) / 1000));
  const m = Math.floor(s / 60);
  const h = Math.floor(m / 60);
  const d = Math.floor(h / 24);
  if (d > 0) return `${d}d`;
  if (h > 0) return `${h}h`;
  if (m > 0) return `${m}m`;
  return `${s}s`;
}
